import gql from 'graphql-tag'

export const GET_KIOSKS = gql`
  query GetKiosks($onlyActive: Boolean) {
    getKiosks(onlyActive: $onlyActive) {
      id
      name
      address
      city
      locationName
      isActive
    }
  }
`
